import { useContext } from 'react';
import MassActionsContext from './context';
import { MassActionsContextState } from './type';

export const useMassActions = (): MassActionsContextState => {
    const ctx = useContext(MassActionsContext);
    if (ctx === null) {
        throw new Error(
            'useMassActions must be inside a MassActionsProvider with a value',
        );
    }
    return ctx;
};

export default useMassActions;
